import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import SchedulerModal from '../../scheduler-modal';
import { useDispatch, useSelector } from 'react-redux';
import { setDeltaMigration, createDeltaMigration } from '../../../store/actions/Migration';

export default function DeltaMigrationTabPanelHome({ setSection }) {

    const dispatch = useDispatch();
    const { migration } = useSelector(st => st['Migration']);
    const [isScheduleMigrationModalOpen, setIsScheduleMigrationModalOpen] = useState(false);

    return (
        <>
            <div style={{ height: '50vh', padding: '0% 4% 4% 4%', display: 'flex' }}>
                <div style={{ width: '100%', height: '60vh', borderRadius: '8px' }}>
                    <div style={{ marginTop: '20px', width: '100%' }}>
                        <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
                            <thead style={{ fontSize: '16px' }}>
                                <tr>
                                    <th style={{ padding: '10px 16px', width: '25%' }}>Name</th>
                                    <th style={{ padding: '10px 16px', width: '25%' }}>Status</th>
                                    <th style={{ padding: '10px 16px', width: '25%' }}>Last Activity</th>
                                    <th style={{ padding: '10px 16px', width: '25%' }}></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '14px' }}>
                                {migration['deltaMigrations'] && migration['deltaMigrations'].length > 0 ? migration['deltaMigrations']?.map((deltaMigration, index) => {
                                    let status = 'In-Progress';
                                    if (['created', 'connected', 'field-mapping'].includes(deltaMigration['status'])) status = 'Drafted';
                                    else if (['sample', 'activated', 'in-progress'].includes(deltaMigration['status']) && deltaMigration['inQueueTasks'] > 0) status = 'In-Progress';
                                    else if (['sample', 'activated'].includes(deltaMigration['status']) && deltaMigration['inQueueTasks'] == 0) status = 'Stopped';
                                    else if (['completed', 'in-progress'].includes(deltaMigration['status']) && deltaMigration['inQueueTasks'] == 0) status = 'Completed';
                                    return (
                                        <tr key={index}>
                                            <td style={{ padding: '18px 16px' }}>{deltaMigration['name']}</td>
                                            <td style={{ padding: '12px 16px', display: 'flex', alignItems: 'center' }}>
                                                <i className={`icon-circle ${status}`}></i> {status}
                                            </td>
                                            <td style={{ padding: '12px 16px' }}>{moment(deltaMigration['updatedAt']).format('lll')}</td>
                                            {
                                                deltaMigration['status'] === 'activated' ? (
                                                    <td style={{ padding: '12px 16px', color: '#2563EB', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
                                                        <button className='btn-style-one' onClick={() => { 
                                                            dispatch(setDeltaMigration(deltaMigration)); 
                                                            setIsScheduleMigrationModalOpen(true); 
                                                        }}> 
                                                            Schedule 
                                                        </button>
                                                        <button className='btn-style-one' style={{ marginLeft: '10px' }} onClick={() => { 
                                                            dispatch(createDeltaMigration({ deltaMigrationId: deltaMigration['_id'], key: deltaMigration['key'] })) 
                                                        }}> 
                                                            Run 
                                                        </button>
                                                    </td>
                                                ) : deltaMigration['status'] === 'scheduled' ? (
                                                    <td>
                                                        Scheduled for {(() => {
                                                            const date = new Date(deltaMigration['scheduledFor']);
                                                            date.setUTCDate(date.getUTCDate() + 1);
                                                            date.setUTCHours(date.getUTCHours() - 5);
                                                            return date.toLocaleString('en-US', {
                                                            month: 'long',
                                                            day: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: false,
                                                            timeZoneName: 'short'
                                                            });
                                                        })()}
                                                    </td>
                                                ) : (
                                                    <td 
                                                        style={{ padding: '12px 16px', color: '#2563EB', cursor: 'pointer' }} 
                                                        onClick={() => {
                                                            dispatch(setDeltaMigration(deltaMigration));
                                                            if (deltaMigration['paymentStatus'] === 'unpaid') setSection('setup');
                                                            else setSection('summery');
                                                        }}
                                                    >
                                                        View
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    )
                                }) : <tr><td className='text-center' colspan="4"> <br /><br />No delta migraiton created yet!</td></tr>}
                            </tbody>
                        </table>
                    </div>
                    <div style={{ marginTop: '5%', display: 'flex', justifyContent: 'end' }}>
                        <button
                            style={{ fontSize: '14px' }}
                            className="btn-style-two" type="button"
                            onClick={() => setSection('overview')} >
                            Start new delta migration
                        </button>
                    </div>
                </div>
            </div>

            {/* ------------------Schedule Migration Setup----------------- */}
            {/* <Modal
                centered
                isOpen={isScheduleMigrationModalOpen}
                className='modal-payment'
                aria-labelledby='contained-modal-title-vcenter'
                style={{width: '80%'}}
            >
                <ModalBody>
                    <div className='payment-box'>
                        <div className='title-area text-center'> <h5>Schedule full migration</h5> </div>
                        <p className='pt-2' style={{ 'fontSize': '17px' }}> Your migration will automatically run at the time you setup below. </p>
                        <br />
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                            <CustomStyleDatePicker date={scheduleMigrationDate} setDate={setScheduleMigrationDate} />
                            <input 
                                type="time" 
                                value={scheduleMigrationTime} 
                                onChange={(e) => setScheduleMigrationTime(e.target.value)} 
                                step="60"
                                style={{ padding: '5px', fontSize: '16px', width: '120px' }} 
                            />
                        </div>
                        <br />
                        <div className='text-center pt-3'>
                            <button className='mx-5 btn-style-two' onClick={() => setIsScheduleMigrationModalOpen(false)}> Cancel </button>
                            <button 
                                className='btn-style-one' 
                                onClick={() => {
                                    dispatch(scheduleFullMigration({ 
                                        type: 'DELTA',
                                        key: migration['key'],
                                        date: scheduleMigrationDate, 
                                        time: scheduleMigrationTime,
                                        data: { deltaMigrationId: newDeltaMigration['_id'], key: newDeltaMigration['key']}
                                    }));
                                    setIsScheduleMigrationModalOpen(false);
                                }}> Schedule migration </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal> */}

            {/* ------------Schedule Migration Modal--------------*/}
            {isScheduleMigrationModalOpen && <SchedulerModal migrationType="DELTA" isScheduleMigrationModalOpen={isScheduleMigrationModalOpen} setIsScheduleMigrationModalOpen={setIsScheduleMigrationModalOpen}/>}
        </>
    );
}
